import { useFlagsWithoutEvaluation } from '@iheartjane/feature-flags';
import { defaultQueryClientConfig } from '@iheartjane/react-query-utils';
import '@iheartjane/reefer/styles/index.css';
import { QueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { createBrowserRouter } from 'react-router';

import { JaneApplicationWrapper } from '@jane/shared/components';

import { createRoutes } from './routes';

export const App = () => {
  const queryClient = useMemo(
    () => new QueryClient(defaultQueryClientConfig),
    []
  );

  const flags = useFlagsWithoutEvaluation();
  const routesObject = createRoutes(queryClient, flags);

  return (
    <JaneApplicationWrapper
      router={createBrowserRouter(routesObject)}
      queryClient={queryClient}
      renderThemeProvider={false}
    />
  );
};
